import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  ConversationOpportunitiesResponseDataSchema,
  DataResponseWithPagination,
  GetConversationOpportunitiesSchema,
} from "schema"
import z from "zod"

type Query = z.input<typeof GetConversationOpportunitiesSchema>
type Response = DataResponseWithPagination<
  z.infer<typeof ConversationOpportunitiesResponseDataSchema>
>

type Props = {
  query: Query
}

function getConversationOpportunitiesQueryKey(query: Query) {
  return ["conversationOpportunities", query] as const
}

export const conversationOpportunitiesQuery = ({ query }: Props) => {
  return queryOptions({
    queryKey: getConversationOpportunitiesQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/opportunities", {
        params: query,
      })
      return data.data
    },
  })
}
